import { mutations } from "./mutations";
import { getters } from "./getters";
import { state } from "./state";

export const notifications = {
  state,
  mutations,
  getters
};
